import axios from "axios";

// action types
export const GIST_GET = "gistGet";

// mutation types
export const SET_LIST = "setList";

const state = {
    list: null
};

const getters = {
    getList(state) {
        return state.list;
    }
};

const actions = {
    [GIST_GET](context) {
        return new Promise((resolve, reject) => {
            axios.get('/api/list').then(response => {
                context.commit(SET_LIST, response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};

const mutations = {
    [SET_LIST](state, data) {
        state.list = data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
